export default {"src":"/_next/static/media/logo-word.76f6e910.svg","height":36,"width":153,"blurWidth":0,"blurHeight":0};